import emotionStyled from '@emotion/styled'
import { InputBase } from '@material-ui/core'
import { Pagination } from '@material-ui/lab'

export const AccountAddressFilterAndActionStyled = emotionStyled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  gap: .75rem;
`
export const AccountAddressFilterStyled = emotionStyled.div`
  height: 50px;
  position: relative;
  flex: 1;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  gap: .5rem;
`
export const AccountAddressActionStyled = emotionStyled.div`
  height: 50px;
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  gap: .5rem;
`
export const AccountAddressInputStyled = emotionStyled(InputBase)`
  width: 100%;
  height: 100%;
  border-radius: 10px;
  box-shadow: rgb(202, 211, 225) 0px 1px 4px 0px;
  display: flex;
  padding: .75rem;
`
export const AddressFormStyled = emotionStyled.div`
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  gap: .75rem;
`
export const AddressInfoWrapper = emotionStyled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  justify-content: start;
  align-items: start;
  gap: .5rem;
  border-radius: 10px;
  background-color: rgba(240, 240, 240, 1);
  padding: .5rem;
  font-size: 14px;
`
export const AddressFormRowStyled = emotionStyled.div`
  width: 100%;
  flex: 1;
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  gap: .75rem;
`
export const AddressFormActionStyled = emotionStyled.div`
  flex: 1;
  width: 100%;
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  gap: .75rem;
`
export const AutocompleteStyled = emotionStyled.div`
  flex: 1;
  width: 100%;
`
export const AccountAddressContentStyled = emotionStyled.div`
  flex: 1;
  position: relative;
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
  justify-content: start;
  align-items: start;
  gap: .75rem;
`
export const AccountAddressContentLists = emotionStyled.div`
  flex: 1;
  position: relative;
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
  justify-content: start;
  align-items: start;
  gap: .75rem;
`
export const AccountAddressContentListItem = emotionStyled.div`
  box-sizing: border-box;
  width: 100%;
  background-color: white;
  position: relative;
  border-radius: 10px;
  background-color: white;
  box-shadow: rgba(49, 53, 59, 0.15) 0px 1px 6px 0px;
  padding: 1rem;
  position: relative;
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
  justify-content: start;
  align-items: start;
  gap: .75rem;
`
export const ListItemContent = emotionStyled.div`
  width: 100%;
  position: relative;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: center;
  gap: .5rem;
  & > span {
    flex: 1;
    font-size: 1.12rem;
    color: rgba(49, 53, 59, 0.9);
    font-weight: 700;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .need-update {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    height: 24px;
    font-size: 12px;
    font-weight: 700;
    border-radius: 1rem;
    padding: .25rem .5rem;
    background-color: rgb(0, 104, 225) !important;
    color: white;
  }
  & > div {
    display: flex;
    gap: .5rem;
    border-radius: 8px;
    font-weight: 600;
    text-transform: capitalize !important;
    &.chip {
      background-color: #e0f2ff;
      color: rgba(49, 53, 59, 0.9);
    }
    &.chip-store {
      background-color: #fff5e2;
      color: rgba(49, 53, 59, 0.9);
    }
    &.chip-return {
      background-color: #ffe0ea;
      color: rgba(49, 53, 59, 0.9);
    }
  }
`
export const ListItemContentAction = emotionStyled.div`
  position: relative;
  display: flex;
  flex-flow: row wrap;
  justify-content: start;
  align-items: center;
  gap: .5rem;
`
export const AccountAddressContentPagination = emotionStyled(Pagination)`
  margin: 0 auto !important;  
  position: relative !important;
  display: flex !important;
  flex-flow: row nowrap !important;
  gap: .75rem !important;
`
